module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero is-medium project-header"
  }, [_c('img', {
    staticClass: "project-header-img-desktop",
    attrs: {
      "src": '../../static/img/common/home_poster.jpg'
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "content-inner"
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('task-list', {
      attrs: {
        "project": project,
        "index": index
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-661cf964!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/containers/main.vue
// module id = 30
// module chunks = 1